import { Inject, Injectable } from "@angular/core";

import { CommonDialogsService } from "@tylertech/common-dialogs-module";
import { IAggregate, ICardData, ICardAction } from "@tylertech/tyler-api-types";

import { IAggregateActionHandler } from "../interfaces";
import { AggregateHelperService } from "../services";

const financeAggregateProvidersIds: ReadonlySet<string> = new Set<string>(
    [
        "Finance.RequisitionApproval",
        "Purchasing.OpenRequisitions",
        "AccountsPayable.InvoiceApprovals",
        "FixedAssets.AssetApprovals",
        "FixedAssets.ImprovementApprovals",
    ]);

const personnelAggregateProvidersIds: ReadonlySet<string> = new Set<string>(
    [
        "Personnel.LeaveRequest",
        "Personnel.TimeEntryApproval",
    ]);


/**
 * TODO - this needs to be moved to elsewhere... or made a more general case...
 */
@Injectable()
export class FinanceApprovalActionHandler implements IAggregateActionHandler
{
    constructor(
        private readonly $commonDialogsService: CommonDialogsService,
        private readonly $aggregateHelperService: AggregateHelperService)
    { }

    predicate(aggregate: IAggregate, _cardData: ICardData, action: ICardAction): boolean
    {
        return isFinanceApprovalAction() || isPersonnelApprovalAction();

        function isFinanceApprovalAction(): boolean
        {
            return financeAggregateProvidersIds.has(aggregate.AggregateProviderId)
                && (action.Id === "Approve" || action.Id === "Reject");
        }
        function isPersonnelApprovalAction(): boolean
        {
            return personnelAggregateProvidersIds.has(aggregate.AggregateProviderId)
                && action.Id === "Reject";
        }
    }

    execute(aggregate: IAggregate, cardData: ICardData, action: ICardAction): Promise<ICardData>
    {

        return this.$commonDialogsService.showComment(action.Id)
            .then((result: string) =>
            {
                if (this.$commonDialogsService.dialogCanceled(result))
                    return;
                cardData.DataElements.push(
                    {
                        Label: "comment",
                        Value: result,
                        Visible: false,
                        Type: "comment",
                        ActionItems: null,
                        Icon: null,
                    });
                return this.$aggregateHelperService.performServerCardAction(aggregate, cardData, action);
            });
    }

    load(_aggregate: IAggregate, _cardData: ICardData, _action: ICardAction): void
    {
        /* NO_OP */
    }
}
